import { createApp } from 'vue'
import App from './App.vue'
import { initializeI18n } from './core/i18n'
import { initializeNetworkMonitoring } from './core/network'
import { applyPreferences } from './core/preferences'
import { initializePwa } from './core/pwa'
import { initializeRouter } from './core/router'
import { initializeShortcuts } from './core/shortcuts'
import { observeCoreWebVitals } from './core/metrics'
import './styles.css'

initializeI18n()
applyPreferences()
initializeRouter()
initializeNetworkMonitoring()
initializeShortcuts()
initializePwa()
observeCoreWebVitals()
createApp(App).mount('#app')
